import { useState, useEffect } from 'react';
import { getContentfulField, unwrapContentfulFields } from 'common/components';

export const useEventBlueprint = (adEventsService) => {
  const [blueprint, setBlueprint] = useState({
    asset: null,
    featuredSectionTitle: '',
    featuredSectionDescription: '',
    featuredBackgroundColors: [],
    generalSectionTitle: '',
    generalBackgroundColors: [],
    heroEventIds: [],
    featuredEventIds: [],
  });

  useEffect(() => {
    const fetchBlueprint = async () => {
      try {
        const data = await adEventsService.getEventsBlueprint();

        if (!Array.isArray(data) || !data.length || !data[0]?.object?.fields) {
          console.warn('Invalid blueprint data received:', data);
          return;
        }

        const fields = data[0].object.fields;

        setBlueprint({
          asset: unwrapContentfulFields(fields.asset) || null,
          featuredSectionTitle:
            getContentfulField(fields.featuredEventsSectionTitle) || '',
          featuredSectionDescription:
            getContentfulField(fields.featuredEventsSectionDescription) || '',
          featuredBackgroundColors:
            getContentfulField(fields.backgroundColorFeaturedEvents) || [],
          generalSectionTitle:
            getContentfulField(fields.generalEventsSectionTitle) || '',
          generalBackgroundColors:
            getContentfulField(fields.backgroundColorUpcomingEvents) || [],
          heroEventIds: unwrapContentfulFields(fields.heroFeaturedEvents) || [],
          featuredEventIds: getContentfulField(fields.featuredEvents) || [],
        });
      } catch (error) {
        console.error('Error fetching blueprint:', error);
      }
    };

    fetchBlueprint();
  }, [adEventsService]);

  return blueprint;
};
